module.exports = [
    { name: 'Membership', reordable: true, id: 'membershipSnapshot.name', numeric: false },
    { name: 'Service name', reordable: false, numeric: false },
    { name: 'Start', reordable: true, id: 'startDate', numeric: false },
    { name: 'Expiry', reordable: false, numeric: false },
    { name: 'Freq', reordable: false, numeric: false },
    { name: 'Monthly price', reordable: false, numeric: false },
    { name: 'Payment date', reordable: false, numeric: false },
    { name: 'Status', reordable: true, id: 'status', numeric: false },
    { name: '# Services', reordable: false, numeric: true },
    { name: '# Used', reordable: false, numeric: true },
    { name: '# Remaining', reordable: false, numeric: true },
    { name: 'Next booking window', reordable: false, numeric: false },
    { name: 'Options', reordable: false, numeric: false }
];
